import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, SUPPORTED_LANGS } from "./translations";

const LangCtx = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("kuryarti.lang");
    if (saved && translations[saved]) return saved;
    const browser = (navigator.language || "en").slice(0, 2);
    return translations[browser] ? browser : "en";
  });

  const setLang = (code) => {
    if (translations[code]) {
      setLangState(code);
      localStorage.setItem("kuryarti.lang", code);
      document.documentElement.lang = code;
    }
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(() => {
    const t = translations[lang];
    return { lang, setLang, t, langs: SUPPORTED_LANGS };
  }, [lang]);

  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LangCtx);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
